<template>
  <div id="LoginSuccessPage"></div>
</template>

<script>
import { mapMutations } from "vuex";

import TokenManager from "@/managers/TokenManager";

export default {
  name: "LoginSuccessPage",
  methods: {
    ...mapMutations({
      setStoreEucToken: "SET_EUC_DEVICE",
      setStoreAdfsToken: "SET_ADFS_TOKEN"
    })
  },
  mounted() {
    // Setup ADFS token
    const key = this.$route.query.k.toString();
    const adfsToken = this.$route.query.t.toString();
    const isEucDevice = this.$route.query.e;

    TokenManager.decryptToken(key, adfsToken);
    TokenManager.setEucToken(isEucDevice);

    this.$router.push({ name: "home" });
  }
};
</script>
